// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EventList_wrap__20TCY","btnWrap":"EventList_btnWrap__i3C_D"};